module.exports = __webpack_public_path__ + "static/the-lancashire-hotpots-egg-sausage-chips-beans-remix-carousel-2ebf9bb10c7d87680a7738d7f0fa55c2.jpg";